import { axiosRequest, atsRequest } from "../../configs/axios.config";

export class ApplicantsService {
  getApplicantById(tenantId, id, success, error) {
    const url = !!!tenantId
      ? `/applicants/${id}`
      : `/tenants/${tenantId}/applicants/${id}`;

    axiosRequest
      .get(url)
      .then(({ data }) => success(data))
      .catch((errorResp) => error(errorResp));
  }

  getApplicantByUrlSearch(applicant_id, success, error) {
    axiosRequest
      .get(`/applicants/${applicant_id}?url_search=true`)
      .then(({ data }) => success(data))
      .catch((errorResp) => error(errorResp));
  }

  updateById(
    id,
    applicantData,
    contentType = "multipart/form-data",
    success,
    error
  ) {
    axiosRequest
      .put(`/applicants/${id}`, applicantData, {
        headers: {
          "Content-Type": contentType,
        },
      })
      .then(({ data }) => success(data))
      .catch((errorResp) => error(errorResp));
  }

  deleteCurriculum(
    idApplicant,
    contentType = "multipart/form-data",
    success,
    error
  ) {
    axiosRequest
      .put(`/applicants/${idApplicant}/delete_curriculum`, {
        headers: {
          "Content-Type": contentType,
        },
      })
      .then(({ data }) => success(data))
      .catch((errorResp) => error(errorResp));
  }

  createWorkExperience(applicant_id, workData, success, error) {
    axiosRequest
      .post(`/applicants/${applicant_id}/work_experiences`, workData, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(({ data }) => success(data))
      .catch((errorResp) => error(errorResp));
  }

  createEducation(applicant_id, educationData, success, error) {
    axiosRequest
      .post(`/applicants/${applicant_id}/educations`, educationData, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(({ data }) => success(data))
      .catch((errorResp) => error(errorResp));
  }

  updateList(applicantId, listData, success, error) {
    axiosRequest
      .put(`/applicants/${applicantId}/update_list`, listData)
      .then(({ data }) => success(data))
      .catch(error);
  }

  sendInformationEmail(applicantId, success, error) {
    axiosRequest
      .post(`/applicants/${applicantId}/request_information_email`)
      .then(({ data }) => success(data))
      .catch((errorResp) => error(errorResp));
  }

  getComments(applicantId, success, error) {
    axiosRequest
      .get(`/applicants/${applicantId}/logs?type=user`)
      .then(({ data }) => success(data))
      .catch((errorResp) => error(errorResp));
  }

  getHistoryLogs(applicantId, success, error) {
    axiosRequest
      .get(`/applicants/${applicantId}/logs?type=list`)
      .then(({ data }) => success(data))
      .catch((errorResp) => error(errorResp));
  }

  createComment(applicantId, dataComment, success, error) {
    axiosRequest
      .post(`/applicants/${applicantId}/logs`, dataComment)
      .then(({ data }) => success(data))
      .catch((errorResp) => error(errorResp));
  }

  updateComment(applicantId, commentId, dataComment, success, error) {
    axiosRequest
      .put(`/applicants/${applicantId}/logs/${commentId}`, dataComment)
      .then(({ data }) => success(data))
      .catch((errorResp) => error(errorResp));
  }

  deleteComment(applicantId, commentId, success, error) {
    axiosRequest
      .delete(`/applicants/${applicantId}/logs/${commentId}?type=user`)
      .then(({ data }) => success(data))
      .catch((errorResp) => error(errorResp));
  }

  getExternalTests(applicantId, success, error) {
    axiosRequest
      .get(`/applicants/${applicantId}/external_tests`)
      .then(({ data }) => success(data))
      .catch((errorResp) => error(errorResp));
  }

  getProfilePdf(applicantId, success, error) {
    atsRequest
      .get(`/applicants/${applicantId}/get_cv_pdf`)
      .then(({ data }) => success(data))
      .catch((errorResp) => error(errorResp));
  }

  move(applicantId, selectionProcess, success, error) {
    axiosRequest
      .post(`/applicants/${applicantId}/move_in_new_list`, selectionProcess)
      .then(({ data }) => success(data))
      .catch((errorResp) => error(errorResp));
  }

  clone(applicantId, selectionProcess, success, error) {
    axiosRequest
      .post(`/applicants/${applicantId}/clone_in_new_list`, selectionProcess)
      .then(({ data }) => success(data))
      .catch((errorResp) => error(errorResp));
  }

  deleteApplicant(applicantId, success, error) {
    axiosRequest
      .delete(`/applicants/${applicantId}/destroy_from_selection_process`)
      .then(({ data }) => success(data))
      .catch((errorResp) => error(errorResp));
  }

  requalify(applicantId, success, error) {
    axiosRequest
      .patch(`/kanban/applicants/requalify`, { applicant_ids: [applicantId] })
      .then(({ data }) => success(data))
      .catch((errorResp) => error(errorResp));
  }

  updateHiring(id, params, success, error) {
    axiosRequest
      .put(`/applicants/${id}/update_hiring`, params)
      .then(({ data }) => success(data))
      .catch((err) => error(err));
  }

  getAssessmentResults(applicantId, success, error) {
    axiosRequest
      .get(`/kanban/applicants/${applicantId}/assessment_results`)
      .then(({ data }) => success(data))
      .catch((err) => console.error(err));
  }

  saveAssessment(applicantId, assessment, success, error) {
    axiosRequest
      .post(`/kanban/applicants/${applicantId}/assessment_results`, assessment)
      .then(({ data }) => success(data))
      .catch((err) => error(err));
  }

  disqualify(
    applicantId,
    reason_id,
    comment,
    sendNotification = false,
    success,
    error
  ) {
    axiosRequest
      .patch("/kanban/applicants/disqualify", {
        applicant_ids: [applicantId],
        reason_id,
        comment,
        send_notification: sendNotification,
      })
      .then(({ data }) => success(data))
      .catch((err) => error(err));
  }

  getQuestionary(applicantId, success, error) {
    axiosRequest
      .get(`/applicants/${applicantId}/get_questionary`)
      .then(({ data }) => success(data))
      .catch((err) => error(err));
  }

  getApplicantForms = (applicantId, success, error) => {
    axiosRequest
      .get(`/applicants/${applicantId}/get_forms`)
      .then(({ data }) => success(data))
      .catch((err) => error(err));
  };

  getReportFile(applicantId, success, error) {
    axiosRequest
      .post(`/report_files`, { applicant_id: applicantId })
      .then(({ data }) => success(data))
      .catch((err) => error(err));
  }

  getContratationData(applicantId, success, error) {
    axiosRequest
      .get(`/applicants/${applicantId}/contratation_data`)
      .then(({ data }) => success(data))
      .catch((err) => error(err));
  }
}
